import Alert from '@/Shared/Alert'
import Button from '@/Shared/Button'
import Dialog from '@/Shared/Dialog/Index'
import Radio from '@/Shared/Forms/Radio'
import { router, useForm } from '@inertiajs/react'
import { usePage } from '@inertiajs/react'
import { useState } from 'react'

export default function ApproveReviewDialog({ open, onCanceled }) {
  const { transaction } = usePage().props
  const [submitting, setSubmitting] = useState(false)

  const { data, setData, clearErrors, errors } = useForm({
    cap_entry_date_basis: 'completed_at',
  })

  const onSubmit = () => {
    setSubmitting(true)

    router.post(route('transactions.approve', transaction.id), data, {
      only: ['flash', 'history', 'transaction'],
      onSuccess: () => {
        onCanceled()
        setSubmitting(false)
      },
    })
  }

  return (
    <Dialog
      footerActions={
        <Button type="submit" theme="solid" onClick={() => onSubmit()} disabled={submitting}>
          Approve & Complete Transaction
        </Button>
      }
      size="sm:max-w-xl"
      show={open}
      title="Approve & Complete Transaction"
      onClosed={onCanceled}
      focusCancelButton
    >
      <div className="mb-4 space-y-6">
        <Alert
          heading={
            <p>
              This action is <span className="font-bold uppercase text-red-600">final</span> and can't be reversed.
            </p>
          }
          subtext="Are you sure you would you like to continue?"
          type="danger"
        />

        <div>
          <label className="mb-3 block font-semibold uppercase">
            <span>CAP History entries will be based on:</span>
          </label>

          <div className="space-y-4">
            <Radio
              id="completed_at"
              name="cap_entry_date_basis"
              label="Today's Date"
              description={
                <span>
                  This option will add CAP history entries using each Associate's{' '}
                  <span className="font-bold underline">Current Remaining CAP</span>.
                </span>
              }
              value="completed_at"
              checked={data.cap_entry_date_basis === 'completed_at'}
              onChange={() => setData('cap_entry_date_basis', 'completed_at')}
            />
            <Radio
              id="closing_at"
              name="cap_entry_date_basis"
              label="Closing Date"
              description={
                <span>
                  This option will add CAP History entries using the Closing Date (
                  <span className="font-bold underline">{transaction.closing_date_formatted}</span>) for this transaction.
                  <br />
                  <br />
                  <span className="font-bold text-red-600">Use with Caution:</span> Choosing this option will have an undesirable impact on
                  CAP calculations unless you are replacing a previously logged manual entry.
                </span>
              }
              value="closing_at"
              checked={data.cap_entry_date_basis === 'closing_at'}
              onChange={() => setData('cap_entry_date_basis', 'closing_at')}
            />
          </div>
        </div>
      </div>
    </Dialog>
  )
}
